<rask-header>
  <rask-action-button
    aid="buttonRaskSparaSokning"
    class="mt-4"
    color="tertiary"
    [ngbTooltip]="tooltipContent"
    tooltipClass="save-search-filter-tooltip"
    (hidden)="onClose()"
    #tooltip="ngbTooltip"
    autoClose="outside"
    triggers="click"
    icon="far fa-save">
    Spara sök
  </rask-action-button>
</rask-header>

<ng-template #tooltipContent>
  <rask-input label="Ange namn" [(ngModel)]="filter.namn" [required]="true" aid="inputSparaSokAngeNamn"></rask-input>
  <div class="row buttons">
    <rask-button color="primary" (click)="trySave()" aid="buttonSparaSokFilter">Spara</rask-button>
    <rask-button color="secondary" (click)="abort()" aid="buttonSparaSokFilterAvbryt">Avbryt</rask-button>
  </div>
  <div class="row">
    @if (errors) {
      <div class="feedback-panel">
        @for (error of errors; track error) {
          <small class="text-danger">{{error}}</small>
        }
      </div>
    }
  </div>
</ng-template>
